import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { RfpProfessionalQuestionInfo } from '@/components/modules/pages/rfp/professional/Surface/RfpProfessionalQuestionInfo';
import { getIsDisclose, getIsDiscloseApproved, } from '@/utils/modules/viewRequest/disclose';
import { RFP_ONLINE_QUESTION_INITIAL_VALUES } from '../../../../../define/consts/rfp/professional_rfp_form_define';
import { propShape, propFunc, propStr, } from '../../../../../helpers/custom-prop-types';
import RfpQuestionAddContentForm from './RfpQuestionAddContentForm';
const RfpQuestionAddContent = (props) => {
    const { formName, onSubmit, onSubmitFail, question, rfp } = props;
    const { id } = rfp;
    // 開示状態が「公開」か判定
    const isDisclose = getIsDisclose(rfp.is_disclose);
    // 開示済みか判定
    const isDiscloseApproved = getIsDiscloseApproved(rfp.is_disclose_approved);
    const { can_add_question_count: canAddQuestionCount } = question;
    return (_jsx("div", Object.assign({ className: 'rfp_question_content' }, { children: _jsxs("div", Object.assign({ className: 'rfp_question_content_add' }, { children: [_jsx("div", Object.assign({ className: 'rfp_x_pad' }, { children: _jsx(RfpProfessionalQuestionInfo, { className: 'rfp_question_content_top', id: id, isCanAddQuestion: true, isDisclose: isDisclose, isDiscloseApproved: isDiscloseApproved }) })), _jsx(RfpQuestionAddContentForm, { canAddQuestionCount: canAddQuestionCount, form: formName, id: id, initialValues: RFP_ONLINE_QUESTION_INITIAL_VALUES, onSubmit: onSubmit, onSubmitFail: onSubmitFail })] })) })));
};
RfpQuestionAddContent.propTypes = {
    formName: propStr().isRequired,
    onSubmit: propFunc().isRequired,
    onSubmitFail: propFunc().isRequired,
    question: propShape().isRequired,
    rfp: propShape().isRequired,
};
export default RfpQuestionAddContent;
